import {Component, EventEmitter, inject, Output} from '@angular/core';
import {POLARIS_HOME_SUGGESTED_QUESTIONS, POLARIS_HOME_SUGGESTED_QUESTIONS_AMOUNT} from '../../../types';
import {UtilService} from '../../../../../services/util.service';

@Component({
  selector: 'app-suggested-questions',
  imports: [],
  templateUrl: './suggested-questions.component.html',
  styleUrl: './suggested-questions.component.scss'
})
export class SuggestedQuestionsComponent {
  public questions: string[] = [];
  private utilService: UtilService = inject(UtilService);

  @Output() questionSelected = new EventEmitter<string>();

  ngOnInit(): void {
    this.questions = this.getRandomQuestions();
  };

  public sendQuestionToInputBar(question: string): void {
    this.questionSelected.emit(question);
  }

  private getRandomQuestions(): string[] {
    if (!POLARIS_HOME_SUGGESTED_QUESTIONS.length) {
      return [];
    };
    if (POLARIS_HOME_SUGGESTED_QUESTIONS.length <= POLARIS_HOME_SUGGESTED_QUESTIONS_AMOUNT) {
      return POLARIS_HOME_SUGGESTED_QUESTIONS;
    };
    const indices = new Set<number>();
    while (indices.size < POLARIS_HOME_SUGGESTED_QUESTIONS_AMOUNT) {
      indices.add(this.utilService.getRandomFromRange(0, POLARIS_HOME_SUGGESTED_QUESTIONS.length));
    }
    return [...indices].map(i => POLARIS_HOME_SUGGESTED_QUESTIONS[i]);
  }
}
